import { useEffect } from 'react';
import { useParams } from 'react-router';
import EmbeddedApp, {
  AppLoading,
  AppTopBar,
} from 'domains/PartnersApps/components/EmbeddedApp';
import {
  PINTEREST_APP_CODE,
  PINTEREST_APP_ID,
} from 'domains/PartnersApps/constants';
import { useGetApp } from '../../hooks';

function AppPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const appId = id === PINTEREST_APP_CODE ? PINTEREST_APP_ID : id;
  const { status, app, fetchApp } = useGetApp(appId);

  useEffect(() => {
    fetchApp();
  }, [fetchApp]);

  if (status.isLoading || app === null) return <AppLoading />;

  const shouldHideTopbar = app.id.startsWith('social-');

  return (
    <EmbeddedApp
      id={app.id}
      url={app.url}
      topBar={shouldHideTopbar ? undefined : <AppTopBar app={app} />}
    />
  );
}

export default AppPage;
